import { observer } from 'mobx-react-lite'
import { Button, SpinnerLoader, Typography } from 'shared/ui'
import { LINK_TEAMS_GUIDE } from 'shared/constants/links'
import { useTeamsContext } from 'pages/settings/pages/teams/context/teamsContext'
import { TeamsListTable } from 'pages/settings/pages/teams/ui/TeamsListTable/TeamsListTable'
import { TeamsListSearch } from 'pages/settings/pages/teams/ui/TeamsList/TeamsListSearch'
import { ImportFromHubSpotDropdown } from 'pages/settings/pages/teams/ui/ImportFromHubSpotDropdown'

import styles from './styles.module.scss'

export const TeamsList = observer(() => {
  const teamsStore = useTeamsContext()
  const { loading, navigateToCreateTeam } = teamsStore

  return (
    <div className={styles.content}>
      <div className={styles.pageHeader}>
        <div className={styles.headerDetails}>
          <Typography variant='heading-lg' ariaLabel='Teams_title'>
            Teams
          </Typography>
          <Typography variant='body-md-regular' ariaLabel='Teams_subtitle_text' color='tertiary'>
            {'Organize members into teams. '}
            <Typography key={'link'} variant={'body-md-regular'} linkLight ariaLabel={'LearnMore'}>
              <a href={LINK_TEAMS_GUIDE} target={'_blank'} rel='noreferrer'>
                Learn more
              </a>
            </Typography>
          </Typography>
        </div>
        <div className={styles.headerActions}>
          <Button
            text='New team'
            size='medium'
            iconProps={{ icon: 'add' }}
            className={styles.createButton}
            onClick={navigateToCreateTeam}
          />
          <ImportFromHubSpotDropdown teamsStore={teamsStore} className={styles.importButton} />
        </div>
      </div>
      <div className={styles.pageContent}>
        <TeamsListSearch />
        {loading ? <SpinnerLoader ariaLabel={'TeamsListTable'} /> : <TeamsListTable />}
      </div>
    </div>
  )
})
